/** Activar el acceso freemium público (formulario en `/`). */
export const FREEMIUM_ENABLED = true;

/** Campo «¿En qué ámbito trabajas?» del formulario de inicio. */
export const OFICIO_ENABLED = false;
